import { isEmpty, isArray, isObject } from "lodash";

const keysToFilter = ["_and", "_or"];

// This function reduces hasura filters to their simplest form to prevent
// unnecessary complexity in the query.
export const simplifyHasuraFilters = <T extends Record<string, any>>(
  filter: T | undefined | null,
): Partial<T> => {
  if (filter === null || filter === undefined) {
    return {};
  }

  const result: Partial<T> = {};

  for (const key in filter) {
    const value = filter[key];

    if (value === null || value === undefined) {
      continue;
    }

    if (isObject(value) && !isArray(value)) {
      result[key] = simplifyHasuraFilters(value) as T[keyof T];
    } else if (isArray(value)) {
      const simplified = value
        .map((item) => (isObject(item) ? simplifyHasuraFilters(item) : item))
        .filter((item) => !keysToFilter.includes(key) || !isEmpty(item));

      if (simplified.length > 0 || !keysToFilter.includes(key)) {
        result[key] = simplified;
      }
    } else {
      result[key] = value;
    }
  }

  return result;
};
